import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const SecurityLockIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4725 2.32892C11.211 1.70124 9.66727 1.33203 8 1.33203C6.33273 1.33203 4.789 1.70124 3.52744 2.32892C2.90879 2.63674 2.59946 2.79064 2.29973 3.27455C2 3.75846 2 4.22702 2 5.16412V7.4901C2 11.279 5.02824 13.3856 6.782 14.2879C7.27113 14.5396 7.51567 14.6654 8 14.6654C8.48433 14.6654 8.72887 14.5396 9.21793 14.2879C10.9717 13.3856 14 11.279 14 7.4901V5.16412C14 4.22702 14 3.75847 13.7003 3.27455C13.4005 2.79064 13.0912 2.63674 12.4725 2.32892Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66602 6.66536V5.66536C6.66602 4.92898 7.26295 4.33203 7.99935 4.33203C8.73575 4.33203 9.33268 4.92898 9.33268 5.66536V6.66536"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33268 6.66797H6.66602C6.11373 6.66797 5.66602 7.1157 5.66602 7.66797V8.66797C5.66602 9.22024 6.11373 9.66797 6.66602 9.66797H9.33268C9.88495 9.66797 10.3327 9.22024 10.3327 8.66797V7.66797C10.3327 7.1157 9.88495 6.66797 9.33268 6.66797Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
